import React, { useEffect } from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import Sidebar from '../layout/sidebar';
import DeviceTypeContent from './content';
import ActionsBar from './actionsBar';
import * as DTypes from '../../modules/devicetypes';
import { Groups } from '../../models';

const DeviceTypesPage: React.FC = () => {
  useEffect(() => DTypes.updateColumns(), []);

  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={<DeviceTypeContent />}
      menu={
        <Menu title={DTypes.msgTitle}>
          <ActionsBar />
        </Menu>
      }
      sidebar={<Sidebar selectedGroup={Groups.DEVICETYPES} />}
    />
  );
};

export default DeviceTypesPage;
